import { Box, CircularProgress } from "@mui/material";

export default function RouteFallback() {
  return (
    <Box
      sx={(theme) => ({
        alignItems: "center",
        bgcolor: theme.palette.surface.default,
        display: "flex",
        justifyContent: "center",
        minHeight: "100vh",
        width: "100%",
      })}
    >
      <CircularProgress size={28} />
    </Box>
  );
}
